import { EventProductMappedToTier } from 'legacy/common/types/models';
import { OutgoingEventProductDto } from 'api/dtos/events/products';

/**
 * Maps a product to a tier.
 */
const mapProductToTier = (product: OutgoingEventProductDto) => {
  let tierStatus: 'available' | 'max' | 'almostMax';

  if (product.status === 'soldOut') {
    tierStatus = 'max';
  } else if (product.status === 'almostSoldOut') {
    tierStatus = 'almostMax';
  } else {
    tierStatus = 'available';
  }

  return {
    name: product.name,
    price: product.price,
    private: product.isPrivate,
    shareToken: product.shareToken,
    totalGuests: product.purchases,
    maxAttendance: product.maxQuantity,
    description: product.description,
    isDisabled: !product.isActive,
    _id: product.id,
    remaining: product.currentStock,
    status: tierStatus,
    startDate: product.startDate,
    endDate: product.endDate,
    requiresApproval: product.purchaseRequirements?.requiresApproval,
    requestStatus: product.purchaseRequirements?.requestStatus,
    questions: product.purchaseRequirements?.questions?.map((question) => ({
      question: question.question,
      _id: question.id
    })),
    imageUrl: product.imageUrl,
    isPrivate: product.isPrivate,
    requiredAssociationIds:
      product.purchaseRequirements?.requiredAssociationIds,
    requiredOrganizationIds:
      product.purchaseRequirements?.requiredOrganizationIds,
    sortIndex: product.sortIndex,
    isVisible: product.isVisible,
    sectionId: product.sectionId,
    type: product.type,
    canDelete: product.canDelete,
    savings: product?.savings
  } as EventProductMappedToTier;
};

export default mapProductToTier;
